// extracted by mini-css-extract-plugin
export default {"container":"jP-z","topReviewHeading":"kP-z","criticalReview":"lP-z","favorableReview":"mP-z","vsSeparator":"nP-z"};